import { Grid, Tab, Tabs } from "@mui/material";
import { Link, Redirect, Route, Switch } from "react-router-dom";
import { useRecoilValue } from "recoil";
import { MDTypography } from "../../Component/Common/Components/MDTypography";
import { BEE123SalariesEditRole, BEE123SalariesViewRole, EE123PeopleRole_Edit, EE123PeopleRole_View, EE123SalariesRole_Edit, EE123SalariesRole_View, PeopleEditRole, PeopleViewRole } from "../../Component/Common/Constants/UserRoles";
import { useRouteMatch } from "../../Helpers/RouteMatcher";
import { userRolesState } from "../../State/user.Atom";
import { IndividualDataTableWithActions } from "./IndividualDataTableWithActions";
import { IndividualSalariesDatatableWithActions } from "./IndividualSalaries/IndividualSalariesDatatableWithActions";

export const CentralDataManagementBase = () => {

    const routes = [
        "/central/Database",
        "/central/Salaries",
    ]

    const routeMatch = useRouteMatch(routes);
    const currentTab = routeMatch?.path;
    let currentTabIndex = routes.findIndex(route => route === currentTab);

    const salaryRoleAccess = [
        EE123SalariesRole_Edit,
        EE123SalariesRole_View,
        BEE123SalariesEditRole,
        BEE123SalariesViewRole
    ];

    const peopleRoleAccess = [
        PeopleEditRole,
        PeopleViewRole,
        EE123PeopleRole_View,
        EE123PeopleRole_Edit
    ];

    const handleRedirect = () => {
        if (currentTabIndex === -1) {
            if (!userRoles.some(r => peopleRoleAccess.includes(r))) {
                return <Redirect to={routes[1]} />;
            }
            return <Redirect to={routes[0]} />;
        }

        return null;
    };

    const userRoles = useRecoilValue(userRolesState);

    return (
        <>
            <MDTypography variant="h4" style={{ paddingBottom: "20px" }}>Central Data Management - Summary</MDTypography>
            <Grid container>
                <Grid item xs={12}>
                    <Tabs value={currentTab} aria-label="Tabs" centered>
                        {userRoles.some(r => peopleRoleAccess.includes(r)) &&
                            <Tab label="People" value={routes[0]} to={routes[0]} component={Link} />}
                        {userRoles.some(r => salaryRoleAccess.includes(r)) &&
                            <Tab label="Salaries" value={routes[1]} to={routes[1]} component={Link} />}
                    </Tabs>
                </Grid>
                <Grid item xs={12} mt={1}>
                    <Switch>
                        {handleRedirect()}
                        <Route path={routes[0]}>
                            <IndividualDataTableWithActions />
                        </Route>
                        <Route path={routes[1]}>
                            <IndividualSalariesDatatableWithActions />
                        </Route>
                    </Switch>
                </Grid>
            </Grid>
        </>);
}